import * as Yup from 'yup';

import * as validation from '../core/utils/validation';

Yup.addMethod(Yup.string, 'notEqualTo', validation.notEqualTo);

/*  export const clientValidationSchema =Yup.object().shape({
  firstName: validation.firstName(true, 'Укажите имя клиента'),
  lastName: validation.lastName(true, 'Укажите фамилию клиента'),
  middleName: validation.middleName(false),
  email: validation.email(false),
  statusRefValueId: Yup.number()
    .moreThan(0, 'Укажите статус клиента')
    .required('Укажите статус клиента'),
  phoneNumber: validation.phone(false),
  contactPhoneNumber1: validation.phone(false)
    .notEqualTo(Yup.ref('phoneNumber'), 'Номер не должен совпадать с phoneNumber')
    .notEqualTo(Yup.ref('contactPhoneNumber2'), 'Номер не должен совпадать с contactPhoneNumber2'),
  contactPhoneNumber2: validation.phone(false)
    .notEqualTo(Yup.ref('phoneNumber'), 'Номер не должен совпадать с phoneNumber')
    .notEqualTo(Yup.ref('contactPhoneNumber1'), 'Номер не должен совпадать с contactPhoneNumber1'),
}); */

export const clientValidationSchema = (lastNameRequired = true) => {
  return Yup.object().shape({
    firstName: validation.firstName(true, 'Укажите имя клиента'),
    lastName: validation.lastName(lastNameRequired, 'Укажите фамилию клиента'),
    middleName: validation.middleName(false),
    email: validation.email(false),
    statusRefValueId: Yup.number()
      .moreThan(0, 'Укажите статус клиента')
      .required('Укажите статус клиента'),
    phoneNumber: validation.phone(false),
    contactPhoneNumber1: validation.phone(false)
      .notEqualTo(Yup.ref('phoneNumber'), 'Номер не должен совпадать с phoneNumber')
      .notEqualTo(Yup.ref('contactPhoneNumber2'), 'Номер не должен совпадать с contactPhoneNumber2'),
    contactPhoneNumber2: validation.phone(false)
      .notEqualTo(Yup.ref('phoneNumber'), 'Номер не должен совпадать с phoneNumber')
      .notEqualTo(Yup.ref('contactPhoneNumber1'), 'Номер не должен совпадать с contactPhoneNumber1'),
  });
};

export const clientSearchValidationSchema = Yup.object().shape({
  phoneMobile: validation.phone(),
});

export const clientEditValidationSchema = Yup.object().shape({
  firstName: validation.firstName(true, 'Укажите имя клиента'),
  lastName: validation.lastName(true, 'Укажите фамилию клиента'),
  middleName: validation.middleName(false),
  email: validation.email(false),
});

export const clientContactPhoneValidationSchema = Yup.object().shape({
  phone: validation.phone(false),
});

export const notificationsControlValidationSchema = Yup.object().shape({
  reason: Yup.string().required('Необходимо указать причину'),
});

export const clientSearchByNameValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .nullable()
    .min(2, 'Минимум 2 символа')
    .matches(/^[а-яё\s]+$/i, 'Поддерживается только кириллица')
    .required('Укажите имя'),
  lastName: Yup.string()
    .nullable()
    .min(2, 'Минимум 2 символа')
    .matches(/^[а-яё\s]+$/i, 'Поддерживается только кириллица')
    .required('Укажите фамилию'),
});

export const bonusEditValidationSchema = Yup.object().shape({
  operationTypeRefValueId: Yup.string()
    .nullable()
    .required('Укажите причину'),
  comment: Yup.string()
    .nullable()
    .required('Укажите тип начисление'),
  bonus: Yup.number()
    .min(0, 'Сумма бонусов должна быть больше 0')
    .integer('Допускается только целое число')
    .test(
      'test- check max bonus',
      'Нельзя начислить более 5000 бонусов',
      function (value) {
        // нельзя начислить клиенту более 5000 бонусов
        if ((this.parent.operationTypeRefValueId === '345') && (value > 5000)) {
          return false;
        }
        return true;
      }
    )
    .test(
      'test- check max bonus',
      'Нельзя списать бонусов больше. чем есть у клиента',
      function (value) {
        // нельзя начислить клиенту более 5000 бонусов
        const value1 = this.parent.maxBonus;
        if ((this.parent.operationTypeRefValueId === '346') && (value > value1)) {
          return false;
        }
        return true;
      }
    )
    .required('Укажите сумму бонусов'),
});

export const clientPassportValidationSchema = Yup.object().shape({
  firstName: validation.firstName(true, 'Укажите имя клиента'),
  lastName: validation.lastName(true, 'Укажите фамилию клиента'),
  middleName: validation.middleName(false),
  passportIssuedDate: Yup.string()
    .nullable()
    .min(10, 'Минимум 10 символов')
    .max(10, 'Максимум 10 символов')
    .required('Укажите дату выдачи паспорта'),
  passportNumber: Yup.string()
    .nullable()
    .min(6, 'Минимум 6 символов')
    .max(6, 'Максимум 6 символов')
    .required('Укажите номер паспорта'),
  passportSeries: Yup.string()
    .nullable()
    .min(4, 'Минимум 4 символа')
    .max(4, 'Максимум 4 символа')
    .required('Укажите номер паспорта'),
  passportIssued: Yup.string()
    .nullable()
    .max(2566, 'Максимум 255 символов')
    .required('Укажите кем выдан'),
});
